import { CAUI } from './ca-ui.js';
import { DropdownButton } from './dropdown-button.js';

export class ColorPicker extends DropdownButton {
  static defaultOptions = {
    componentName: 'ColorPicker',
    color: 'red',
    dropDown: { width: 536, maxHeight: 400 }
  };

  static icons = null;

  constructor (options) {
    super(
      ColorPicker.initOptions($.extend({}, ColorPicker.defaultOptions, options))
    );

    // Common
    this.commonLabel = $('<label>Common colours</label>');
    this.dropDown.add(this.commonLabel);

    this.commonList = $('<ul></ul>');
    this.dropDown.add(this.commonList);

    // All
    this.allLabel = $('<label style="margin-top:20px">All colours</label>');
    this.dropDown.add(this.allLabel);

    this.allList = $('<ul></ul>');
    this.dropDown.add(this.allList);

    this.dropDown.el.on(
      'click',
      function (e) {
        if ($(e.target).hasClass('ca-ui-colorpicker_item')) {
          this.setActiveColorItem($(e.target));
          if (this.options.onSelect) this.options.onSelect(this.options.color);
          this.dropDown.hide();
        }
      }.bind(this)
    );

    if (!ColorPicker.colors) {
      $.ajax(CAUI.basePath + '/assets/json/ui/2.0/colors.json')
        .done(
          function (icons) {
            ColorPicker.colors = icons;
            this.initColorList(icons);
          }.bind(this)
        )
        .fail(function () {
          alert('Cannot load colors');
        });
    } else this.initColorList(ColorPicker.colors);
  }

  initColorList (icons) {
    // Common
    icons.common.forEach(
      function (icon) {
        const item = this.createColorItem(icon);
        this.commonList.append(item);
      }.bind(this)
    );

    // All
    icons.all.forEach(
      function (icon) {
        const item = this.createColorItem(icon);
        this.allList.append(item);
      }.bind(this)
    );
  }

  setActiveColorItem (iconItem) {
    if (this.activeItem) this.activeItem.removeClass('active');

    this.activeItem = iconItem;
    this.activeItem.addClass('active');
    this.options.color = this.activeItem.data('color');
    this.button.icon.el.css('color', this.options.color);
  }

  createColorItem (color) {
    const item = $(
      '<li class="ca-ui-colorpicker_item" data-color="' +
        color.code +
        '" style="background-color:' +
        color.code +
        '"></li>'
    );
    if (color.code === this.options.color) this.setActiveColorItem(item);
    return item;
  }

  setColor (color) {
    this.commonList.find('li[data-color="' + color + '"]').each(
      function (i, item) {
        this.setActiveColorItem($(item));
      }.bind(this)
    );

    this.allList.find('li[data-color="' + color + '"]').each(
      function (i, item) {
        this.setActiveColorItem($(item));
      }.bind(this)
    );
  }

  static initOptions (options) {
    options.button = { label: 'Change', icon: 'circle' };
    return options;
  }
}
